var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconPin48Filled = function SvgIconPin48Filled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 8.299a13.14 13.14 0 0 0-13.2 13.36c0 6.43 5.42 12.12 11.27 17.31a2.9 2.9 0 0 0 3.85 0c5.86-5.19 11.28-10.88 11.28-17.31A13.14 13.14 0 0 0 24 8.299Zm4.87 14.24a5 5 0 1 1-1.34-4.667 4.999 4.999 0 0 1 1.34 4.657v.01Z",
    fill: "current"
  })));
};
export default SvgIconPin48Filled;